var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333333 332409",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 7071.65,
    y1: 170259,
    x2: 16701.2,
    y2: 266676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#de4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#bf190b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf190b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 229084,
    y1: 283.071,
    x2: 330328,
    y2: 44973.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#910f08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#791c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791c12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: -2119.29,
    y1: 232219,
    x2: 232152,
    y2: -8677.95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#c82f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#820c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#a31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#b31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#e82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 338234,
    y1: 111472,
    x2: 232299,
    y2: -1778.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#9e120b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e120b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 163085,
    y1: 105566,
    x2: 170920,
    y2: 246594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#e4714e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#be1a0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 192204,
    y1: 37586.2,
    x2: 275485,
    y2: -4054.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#c81f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#bf0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 57570.9,
    y1: 331724,
    x2: 25269.7,
    y2: 222137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#9e100a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#b3100c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3100c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 329979,
    y1: 235589,
    x2: 198630,
    y2: 117866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e110b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e110b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#9e0c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e0c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 55192.9,
    y1: 204299,
    x2: 74990.2,
    y2: 332958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#e57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#de3b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#a60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 237761,
    y1: 289526,
    x2: 66382.3,
    y2: 247227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c0c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c0c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#990c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#a80d0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 280817,
    y1: 341377,
    x2: 120451,
    y2: 58242.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#e42b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 252884,
    y1: 26798,
    x2: 274244,
    y2: 118849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 266981,
    y1: 368095,
    x2: 116823,
    y2: 267330
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 325352,
    y1: 275997,
    x2: 225296,
    y2: 208853
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    cx: 241981,
    cy: 134492,
    r: 47248,
    fx: 241981,
    fy: 134492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#7e0e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e0e08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    cx: 125226,
    cy: 245350,
    r: 48389.8,
    fx: 125226,
    fy: 245350
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a30c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a30c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#800e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800e08"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67935 332408l246420-16722 18978-248474-75085 152190L67935 332408z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235889 245513l78870 70004-21181-146183-57690 76180z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68759 332089l246286-16572-155167-12181-91119 28753z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22443 223372l46535 108750 38762-126987-85297 18237z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98133 201905l137738 44028-35666-139706-102072 95678z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201887 116254l123353-8059-96486-78803-26867 86862z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187570 875l92549 420-56747 31361L187570 875z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4541 170966L0 265971l23772-43356-19231-51649z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3263 169333l19348 54880 84069-18859 95981-89201 27087-86038L187099 0l-72511 27137C91740 48387 47409 90429 45812 91220c-1581 807-29274 53146-42548 78113z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71198 70745c49513-49092 113343-78097 137839-53382 24478 24715-1481 84776-50994 133851-49513 49076-112552 79679-137031 54964-24496-24697 672-86357 50186-135433z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68978 332072l38459-127391 127728 41033c-46182 43305-97545 79914-166187 86357z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202830 115901l32789 129880c38578-40562 73202-84170 90159-138107l-122948 8227z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325443 108330c13122-39604 16150-96419-45728-106967l-50775 28045 96503 78922z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 265398c1816 65361 48974 66337 69062 66909L22662 223944 1 265398z",
    fill: "#a00308"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203015 116103c29643 18219 89386 54811 90597 55485 1884 1059 25757-40260 31175-63612l-121772 8126z",
    fill: "url(#m)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107387 204681l51414 99194c30402-16488 54207-36575 76011-58094l-127425-41100z",
    fill: "url(#n)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22459 224078l-7284 86745c13745 18776 32655 20407 52491 18944-14350-35717-43019-107135-45206-105689z",
    fill: "url(#o)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228637 29627l102138 14334c-5451-23099-22191-38005-50724-42665l-51414 28331z",
    fill: "url(#p)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyIcon);
export default __webpack_public_path__ + "static/media/ruby-icon.411dad548f0d95b03faacbf5f38e7960.svg";
export { ForwardRef as ReactComponent };